const parentNodes = document.querySelectorAll(".tabs-coach__wrapper");
// console.log(parentNodes);

if(parentNodes.length > 0) {

    Array.from(parentNodes).forEach(function(children){
        const navNodes = children.querySelectorAll(".tabs-coach__link");
        const contentNodes = children.querySelectorAll(".tabs-coach__content");
        // console.log(navNodes);
        let current = 0;

        if (navNodes.length > 1) {
            const nav = Array.from(navNodes);
            const content = Array.from(contentNodes);

            nav.map((link, key) => {
                link.addEventListener('click', () => {
                    if (!link.classList.contains('is-active')) {
                        
                        nav.map(l => {
                            l.classList.remove('is-active');
                            l.setAttribute('aria-selected', 'false');
                        });
                        content.map(c => {
                            c.classList.remove('is-active');
                        });
                        
                        current = key;

                        link.classList.add('is-active');
                        link.setAttribute('aria-selected', 'true');
                        content[key].classList.add('is-active');

                    }
                });
            });

        }

    }); // END forEach

}